import { z } from "zod";
// Gli eventi delle email di GoHighLevel come li vede l'interfaccia (piano dell'ingresso del 12 ottobre 2026, I5, D5; INGR-22): gli
// stessi di `EMAIL_EVENT_TYPES` del dominio, nell'ordine delle parole della Timeline («Email consegnata», «Email aperta», «Clic su un
// link dell'email», «Email rimbalzata», «Email segnata come spam», «Disiscritto dalle email», «Ha risposto all'email»). Le email non
// si mandano da Gioia365 (PROD-3): gli eventi si leggono e basta.
export const EMAIL_EVENTS = ["delivered", "opened", "clicked", "bounced", "complained", "unsubscribed", "replied"];
export const emailEventSchema = z.enum(EMAIL_EVENTS);
//# sourceMappingURL=email-events.js.map